export default "__VITE_ASSET__CmzwVKUa__"